import { useState } from "react";
import { Button, useToast } from "@chakra-ui/react";
import { billingApi } from "../api/billingApi";
import { fallbackSubscribeUrl, formatPlanPrice } from "../lib/plan";
import { redirectTo } from "../lib/redirect";
import { trackEvent } from "../../../shared/lib/analytics";

// "Assinar — R$ 59/mês": pede ao backend a fatura no gateway e redireciona para ela (o
// médico escolhe Pix, boleto ou cartão lá). Com a assinatura online desligada (503), cai
// no link alternativo REACT_APP_ASSINATURA_URL, se existir.
export default function SubscribeButton({ origin, priceCents, label, ...buttonProps }) {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    trackEvent("checkout_iniciado", { origem: origin });
    setIsLoading(true);
    try {
      redirectTo(await billingApi.checkout());
    } catch (error) {
      setIsLoading(false);
      const fallback = fallbackSubscribeUrl();
      if (error.response?.status === 503 && fallback) {
        redirectTo(fallback);
        return;
      }
      toast({
        title:
          error.response?.status === 503
            ? "A assinatura online ainda não está disponível"
            : "Não foi possível abrir a assinatura",
        description: error.response?.status === 503 ? undefined : error.response?.data?.mensagem,
        status: error.response?.status === 409 ? "info" : "error",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  return (
    <Button size="sm" flexShrink={0} isLoading={isLoading} onClick={handleClick} {...buttonProps}>
      {label ?? `Assinar — ${formatPlanPrice(priceCents)}`}
    </Button>
  );
}
